import IconActionButton from "./IconActionButton";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";

const RepairIconButton = ({title, disabled = false, onClick}) => (
    <IconActionButton
        disabled={disabled}
        title={title}
        onClick={onClick}
        className="text-emerald-700"
    >
        <BuildOutlinedIcon fontSize="small"/>
    </IconActionButton>
);

export default RepairIconButton;